import { useEffect } from "react";
import { useNavigate, Outlet } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Sidebar from "../components/Sidebar";
import MobileDashboardMenus from "../components/MobileDashboardMenus";

export default function AppLayout() {
  const navigate = useNavigate();

  useEffect(() => {
    const handleUnauthorized = () => navigate('/login', { replace: true });
    window.addEventListener('stocknow:unauthorized', handleUnauthorized);
    return () => window.removeEventListener('stocknow:unauthorized', handleUnauthorized);
  }, [navigate]);

  return (
    <div>
      <Header />
      <main className="grid grid-cols-1 md:grid-cols-12 min-h-screen 2xl:max-w-[80vw] max-w-[95vw] mx-auto px-4 py-3">
        <MobileDashboardMenus />
        <Sidebar />
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
